/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R4_AndInputs */

const tr_iletisim_s7_r4_and = /** @type {(inputs: Iletisim_S7_R4_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ve`)
};

const en_iletisim_s7_r4_and = /** @type {(inputs: Iletisim_S7_R4_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

const de_iletisim_s7_r4_and = /** @type {(inputs: Iletisim_S7_R4_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const ru_iletisim_s7_r4_and = /** @type {(inputs: Iletisim_S7_R4_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`и`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Iletisim_S7_R4_AndInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r4_and = /** @type {((inputs?: Iletisim_S7_R4_AndInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R4_AndInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r4_and(inputs)
	if (locale === "de") return de_iletisim_s7_r4_and(inputs)
	if (locale === "ru") return ru_iletisim_s7_r4_and(inputs)
	return tr_iletisim_s7_r4_and(inputs)
});